<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>

        <div class="row">
            <div class="col-sm-12 form-group">
                <label for="buscacns">CPF ou CNS</label>
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Digite o CPF ou CNS" id="buscacns" v-mask="'###############'" v-model="documento">
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" id="button-addon2" @click="refreshTokenCallMethod('censo_buscaCns', 'buscaCNS')">
                            <i class="fa fa-search" aria-hidden="true"></i> Buscar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <b-form-checkbox
            v-model="semIdentificacao"
            value="1"
            unchecked-value="0"
        >
            Paciente sem identificação
        </b-form-checkbox>

        <b-alert variant="danger" :show="errorCns != null ? true : false">
            {{errorCns}}
        </b-alert>

        <div class="bordas" v-if="cnsInternacao != null || semIdentificacao == '1'">
            <div v-if="cnsInternacao != null">
                <div class="row">
                    <div class="col-sm-12 form-group">
                        <label>Nome</label>
                        <input class="form-control" disabled :value="cnsInternacao.dados.nomeCompleto">
                    </div>
                </div>

                <div class="row">
                    <div v-if="cnsInternacao.dados.cpf" class="col-sm-6 form-group d-flex flex-column justify-content-end">
                        <label>CPF</label>
                        <input class="form-control" disabled :value="cnsInternacao.dados.cpf">
                    </div>
                    <div v-else class="col-sm-6 form-group d-flex flex-column justify-content-end">
                        <label>CNS</label>
                        <input class="form-control" disabled :value="cnsInternacao.dados.cns">
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 form-group">
                        <label>Data de Nascimento</label>
                        <input class="form-control" disabled :value="nascimento">
                    </div>
                    <div class="col-sm-3 form-group">
                        <label>Idade</label>
                        <input class="form-control" disabled :value="cnsInternacao.dados.idade">
                    </div>
                    <div class="col-sm-3 form-group">
                        <label>Sexo</label>
                        <input class="form-control" disabled :value="cnsInternacao.dados.sexo">
                    </div>
                </div>
            </div>

            <div class="row" v-if="semIdentificacao != '0'">
                <div class="form-group col">
                    <label>Descrição/Nome do paciente</label>
                    <input class="form-control" v-model="nomePacienteDesconhecido" maxlength="100">
                </div>
            </div>

            <div class="row">
                <div class="form-group col">
                    <label>Nome social (paciente)</label>
                    <input class="form-control" v-model="nomeSocial" maxlength="100">
                </div>
            </div>
            

            <div class="row">
                <div class="col-sm-6 form-group">
                    <label to="data-picker">Data Admissão</label>
                    <datepicker
                        v-model="data_internacao_semformatacao"
                        :format="formatoData"
                        :disabled="dateDisabled"
                        language="pt-br"
                        id="data-picker"
                        calendar-button
                        calendar-button-icon="fa fa-calendar"
                        >
                    </datepicker>
                </div>

                <div class="col-sm-6 form-group">
                    <label>Hora Admissão</label>
                    <input class="form-control" type="time" v-model="hora">
                    <small v-if="hora == ''" class="text-danger">preenchimento obrigatório</small>
                </div>
            </div>

            <!-- (select classificacao risco) (chapado, nunca muda)
            1=azul, 2=verde, 3=amarelo, 4=laranja, 5=vermelho, 6=Não se aplica -->

            <div class="row">
                <div class="col-sm-6 form-group">
                    <label>Número do Prontuário</label>
                    <input type="number" class="form-control" v-model="numeroProntuario">
                </div>
                <div class="col-sm-6 form-group">
                    <label>Classificação de Risco</label>
                    <select class="form-control" v-model="classificacaoRisco">
                        <option value="" disabled>Selecione</option>
                        <option :value="1">Azul</option>
                        <option :value="2">Verde</option>
                        <option :value="3">Amarela</option>
                        <!-- <option :value="4" disabled>Laranja</option> -->
                        <option :value="5">Vermelha</option>
                        <option :value="6">Não se aplica</option>
                    </select>
                    <small v-if="classificacaoRisco == ''" class="text-danger">preenchimento obrigatório</small>
                </div>

                <div class="col-sm-6 form-group">
                    <label>Procedência</label>
                    <select class="form-control" v-model="procedencia" v-if="selects">
                        <option value="" disabled>Selecione</option>
                        <option v-for="(item, index) in selects.procedencia" :key="index" :value="item.id">{{item.nome}}</option>
                    </select>
                    <small v-if="procedencia == ''" class="text-danger">preenchimento obrigatório</small>
                </div>
            </div>

            <p v-if="dados.dataHoraUltimaMovimentacao != ''">Última movimentação: {{dados.dataHoraUltimaMovimentacao}}</p>

            <!-- <button type="button" class="btn btn-primary" :disabled="hora.length < 5 ? true : false" @click.once="validaSessao('internaPaciente')">Realizar Admissão</button> -->
            <button type="button" class="btn btn-primary" :disabled="hora.length < 5 ? true : false" @click="internaPaciente()">Realizar Admissão</button>

        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import { captcha } from '../../../shared/mixins/captcha'
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    mixins: [
        captcha,
        validaSessao
    ],
    props: {
        dados: Object
    },
    components: {
        Datepicker
    },
    mounted () {
        let hora = new Date().getHours()
        let min = new Date().getMinutes()
        if (hora < 10) hora = '0' + hora
        if (min < 10) min = '0' + min
        
        this.hora = hora + ':' +  min

        this.desabilitaDatas()
    },
    watch: {
        documento (value) {
            if (value.length > 0) {
                this.semIdentificacao = 0
                this.nomePacienteDesconhecido = ''
            }
        },
        nomePacienteDesconhecido (value) {
            this.nomePacienteDesconhecido = value.toUpperCase()
        },
        semIdentificacao (value) {
            if (value == '1') {
                this.$store.commit("consultas/setCnsInternacao", null)
                this.documento = ''
            }
        },
        nomeSocial (value) {
            this.nomeSocial = value.toUpperCase()
        }
    },
    computed: {
        selects () {
            return this.$store.getters['leitos/getOpcoesSelect']
        },
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        errorCns () {
            return this.$store.getters['consultas/getErrorCns']
        },
        cnsInternacao () {
            return this.$store.getters['consultas/getCnsInternacao']
        },
        token_captcha () {
            return this.$store.getters['sessao/getCaptcha']
        },
        nascimento () {
            if (this.cnsInternacao) return this.cnsInternacao.dados.dataNascimento.substr(8,2) + '/' + this.cnsInternacao.dados.dataNascimento.substr(5,2) + '/' +  this.cnsInternacao.dados.dataNascimento.substr(0,4)
            else return ''
        }
    },
    data () {
        return {
            semIdentificacao: '0',
            nomePacienteDesconhecido: '',
            nomeSocial: '',
            documento: '',
            cnsFixo: '',
            data_internacao_semformatacao: new Date(),
            hora: '',
            formatoData: 'dd/MM/yyyy',
            dateDisabled: {
                ranges: [
                    {
                        from: new Date(1990, 11, 25),
                        to: new Date(1990, 11, 26)
                    },
                    {
                        from: new Date(),
                        to: new Date(2040, 2, 25)
                    }
                ]
            },
            numeroProntuario: '',
            classificacaoRisco: '',			 
            procedencia: ''
        }
    },
    methods: {
        async buscaCNS () {
            if (this.documento.length !== 11 && this.documento.length !== 15) return

            let tpDocumento = ''
            this.documento.length == 11 ?
                tpDocumento = 'cpf' :
                tpDocumento = 'cns'

            this.$store.dispatch('consultas/buscaCnsInternacao', {
                tpDocumento: tpDocumento,
                documento: this.documento,
                captcha: this.token_captcha
            })
            .then(() => {
                tpDocumento === 'cns' ?
                    this.cnsFixo = this.documento :
                    this.cnsFixo = this.cnsInternacao.dados.cns
            })
        },
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        desabilitaDatas () {
            if (this.dados.dataHoraUltimaMovimentacao !== null && this.dados.dataHoraUltimaMovimentacao !== '') {
                let ultimaMovimentacao = this.dados.dataHoraUltimaMovimentacao
                let dia = parseInt(ultimaMovimentacao.substr(0,2))
                let mes = parseInt(ultimaMovimentacao.substr(3,2)) - 1
                let ano = parseInt(ultimaMovimentacao.substr(6,4))

                this.dateDisabled.ranges[0]['to'] = new Date(ano, mes,dia)
            }
        },
        internaPaciente () {
            if (this.hora.length < 5 || this.classificacaoRisco == '' || this.procedencia == '') return
            if (this.semIdentificacao == '1' && this.nomePacienteDesconhecido == '') return

            let datahora = this.formatadata(this.data_internacao_semformatacao) + ' ' + this.hora

            let dados = {
                nomePacienteDesconhecido: this.semIdentificacao == '1' ? this.nomePacienteDesconhecido : '',
                nomeSocial: this.nomeSocial,
                cns:  this.semIdentificacao == '0' ? this.cnsFixo : '',
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                dataHoraInternacao: datahora,
                numeroProntuario: this.numeroProntuario,
                classificacaoRisco: this.classificacaoRisco,			 
                procedencia: this.procedencia    
            }

            this.documento = ''
            this.cnsFixo = ''

            this.$emit('internar', dados)
        }
    }
}
</script>

<style>
    
</style>